import Grid2 from '@mui/material/Unstable_Grid2';

import Button, { ButtonVariant } from '@/components/BaseLibrary/Button/Button';
import useSharedStyles from '@/components/HighlightImageTextStacked/SharedStackedStyles.styles';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import type { ButtonContent } from '@/components/OldButton/OldButton';
import SectionHeader from '@/components/SectionHeader/SectionHeader';
import { brandColors } from '@/styles/sunrunTheme.styles';

import useStyles from './HeaderAndCTA.styles';

interface Props {
  isOnDark: boolean;
  eyebrow?: string;
  headline?: string;
  subheading?: string;
  headerCta?: ButtonContent;
  fullWidth?: boolean;
}

export default function HeaderAndCTA({
  isOnDark,
  eyebrow,
  headline,
  subheading,
  headerCta,
  fullWidth,
}: Props) {
  const cta = headerCta ? { ...headerCta.fields } : null;
  const { classes } = useStyles();
  const { classes: sharedClassees } = useSharedStyles({ isOnDark });

  return (
    <GridContainer2 fixed>
      <Grid2
        xs={12}
        md={fullWidth ? 12 : 6}
        style={{
          color: isOnDark
            ? brandColors.tintsOffWhite40
            : brandColors.tintsNeutral20,
        }}
      >
        {headline && (
          <SectionHeader
            eyebrow={eyebrow}
            heading={headline}
            subheading={subheading}
            isOnDark={isOnDark}
            className={sharedClassees.sectionHeader}
            fixed={true}
          />
        )}
      </Grid2>
      {cta && (
        <Grid2
          xs={12}
          md={fullWidth ? 12 : 6}
          className={classes.optionalCTAGrid}
        >
          <div className={classes.optionalCTAContainer}>
            <Button
              isOnDark={isOnDark}
              variant={ButtonVariant.SECONDARY}
              label={cta?.label}
              href={cta?.url}
            />
          </div>
        </Grid2>
      )}
    </GridContainer2>
  );
}
